import {useCookies} from 'react-cookie';
import SpinnerLoading from '../../../../../components/SpinnerLoading';
import ValueInfo from '../../../../myAccount/my-credits/components/ValueInfo';
import {IBankAccountInfo} from '../../api/getBankAccountInfo/getBankAccountInfo';

interface IBankAccountDataFillProps {
  bankAccountInfo?: IBankAccountInfo;
  onClick: () => void;
  isLoading?: boolean;
}

const BankAccountDataFill = ({
  bankAccountInfo,
  onClick,
  isLoading = false,
}: IBankAccountDataFillProps) => {
  if (isLoading) return <SpinnerLoading size={25} />;

  const [cookie] = useCookies(['user']);

  const isEdit = Boolean(bankAccountInfo?.guid);

  return (
    <div
      className={` rounded-lg ${
        isEdit ? 'bg-zinc-100' : 'bg-[#FAFDF7] text-farm-shop-600'
      }   w-full`}
    >
      <div className="flex flex-col w-full gap-3 p-3">
        <span className="self-start w-full text-sm font-normal text-right ">
          {isEdit ? (
            <div className="relative flex flex-col w-full gap-1">
              <i
                onClick={onClick}
                className="absolute top-0 left-0 text-lg icon-nameEdit text-farm-shop-500"
              />

              <ValueInfo
                title="صاحب حساب"
                value={cookie?.user?.profile?.name}
                titleWidth="4.5rem"
              />
              <ValueInfo
                title="شماره شبا"
                value={bankAccountInfo?.iban_number!}
                titleWidth="4.5rem"
                valueUnit="IR"
                valueUnitClassName="!text-md"
              />
              <ValueInfo
                title="شماره حساب"
                value={bankAccountInfo?.bank_account_number!}
                titleWidth="4.5rem"
              />
            </div>
          ) : (
            'شماره شبا حسابتان را جهت واریز وجه وارد کنید.'
          )}
        </span>

        {!isEdit && (
          <button
            type="button"
            onClick={onClick}
            className="self-end px-3 py-1 text-sm text-white rounded-lg bg-farm-shop-500"
          >
            {!isEdit ? 'افزودن اطلاعات حساب' : ''}
          </button>
        )}
      </div>
    </div>
  );
};

export default BankAccountDataFill;
